import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllPdfs({ payload }) {
  try {
    yield put(actions.addPdfLoading(true));
    const result = yield call(api.getAllPDFs);
    yield put(actions.getAllPdfsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllPdfsFail());
  } finally {
    yield put(actions.addPdfLoading(false));
  }
}

//Edit Tables
function* editPdf({ payload }) {
  try {
    yield put(actions.addPdfLoading(true));
    const result = yield call(api.editPDFs, payload);
    yield put(actions.editPdfSuccess(result.data));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.editPdfFail());
  } finally {
    yield put(actions.addPdfLoading(false));
  }
}

// create
function* createPdf(formData) {
  try {
    yield put(actions.addPdfLoading(true));
    const result = yield call(api.createPDFs, formData.payload);
    yield put(
      actions.createPdfSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    toast.error(error.response.data.message);

    yield put(actions.createPdfFail());
  } finally {
    yield put(actions.addPdfLoading(false));
  }
}

function* deletePdf({ payload }) {
  try {
    yield put(actions.addPdfLoading(true));
    const result = yield call(api.deletePDF, payload);

    yield put(actions.deletePdfSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deletePdfFail());
  } finally {
    yield put(actions.addPdfLoading(false));
  }
}

function* getCoursePdf({ payload }) {
  try {
    yield put(actions.addPdfLoading(true));
    const result = yield call(api.getCoursePDF, payload);
    yield put(actions.getCoursePdfSuccess(result?.data));
  } catch (error) {
    toast.error(error.response);
    yield put(actions.getCoursePdfFail());
  } finally {
    yield put(actions.addPdfLoading(false));
  }
}

export default function* SuperadminPdfSaga() {
  yield takeLatest(Types.GET_SUPERADMIN_PDFS_REQUEST, getAllPdfs);
  yield takeLatest(Types.SUPERADMIN_GET_COURSE_PDF_REQUEST, getCoursePdf);
  yield takeLatest(Types.EDIT_SUPERADMIN_PDF_REQUEST, editPdf);
  yield takeLatest(Types.CREATE_SUPERADMIN_PDF_REQUEST, createPdf);
  yield takeLatest(Types.DELETE_SUPERADMIN_PDF_REQUEST, deletePdf);
}
